import {
  ObjectUnit,
  V2AffordabilitySettings,
  V2AffordabilityStatus
} from '@/types/api'

export const AFFORDABILITY_COLORS = {
  green: '#32c766',
  orange: '#f6a72a',
  red: '#f04e4c'
} as const

export interface BarSegments {
  green: number
  orange: number
  red: number
}

export function getBarSegments(settings?: V2AffordabilitySettings | null): BarSegments {
  const defaults = { green: 33, orange: 2, red: 65 }
  if (!settings) {
    return defaults
  }

  const maximumAffordabilityPercent = Number(settings.maximumAffordabilityPercent)
  const toleranceRangeUpToPercent = Number(settings.toleranceRangeUpToPercent)
  if (!Number.isFinite(maximumAffordabilityPercent) || !Number.isFinite(toleranceRangeUpToPercent)) {
    return defaults
  }

  const max = Math.max(0, Math.min(100, maximumAffordabilityPercent))
  const orange = Math.max(0, Math.min(100 - max, toleranceRangeUpToPercent - max))

  return {
    green: max,
    orange,
    red: 100 - max - orange
  }
}

export function isAffordabilityCalculated(
  status?: V2AffordabilityStatus | null
): boolean {
  return status === V2AffordabilityStatus.AFFORDABILITY_STATUS_CALCULATED
}

export function isAffordabilityNoIncome(
  status?: V2AffordabilityStatus | null
): boolean {
  return status === V2AffordabilityStatus.AFFORDABILITY_STATUS_NO_INCOME
}

export function clampPercent(value: number): number {
  if (!Number.isFinite(value)) {
    return 0
  }
  return Math.max(0, Math.min(100, value))
}

// Normalizes API affordability percent for m²/year rents by dividing by 12; corrects backend's annualization.
export function affordabilityPercentForRentUnit(
  percent: number | null | undefined,
  rentUnit?: string | null
): number {
  const value = Number(percent)
  if (!Number.isFinite(value)) {
    return 0
  }
  if (rentUnit === ObjectUnit.M2YEAR) {
    return value / 12
  }
  return value
}
